<template>
  <div class="about">
    <h1 class="message">{{ message }}</h1>
  </div>
</template>
<script>
export default {
  data() {
    return {
      message: '系统维护中，请稍后再试'
    }
  },
  activated() {
    this.$notification.error({
      message: this.message
    })
    this.$message.error(this.message)
  },
  mounted() {
  },
  methods: {}
}
</script>
<style scoped>
.message {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
